import { render, staticRenderFns } from "./page-header-industry.vue?vue&type=template&id=3a461cb8&scoped=true"
import script from "./page-header-industry.vue?vue&type=script&lang=js"
export * from "./page-header-industry.vue?vue&type=script&lang=js"
import style0 from "./page-header-industry.vue?vue&type=style&index=0&id=3a461cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a461cb8",
  null
  
)

export default component.exports